module.exports = __webpack_public_path__ + "img/LBC logo.45d11f2d.png";